import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { MwDirectivesModule } from '@core/directives/directives.module';
import { MwSharedPipesModule } from 'app/@shared/@pipes';
import {
  AdditionalButtonComponent,
  CancelButtonComponent,
  ConfirmButtonComponent,
  TertiaryButtonComponent,
} from './components/';
import { MwDialogComponent } from './dialog.component';
import { MwDialogService } from './services';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    MatIconModule,
    MatDividerModule,
    MwDirectivesModule,
    MatProgressSpinnerModule,
    MwSharedPipesModule,
  ],
  declarations: [
    MwDialogComponent,
    TertiaryButtonComponent,
    AdditionalButtonComponent,
    ConfirmButtonComponent,
    CancelButtonComponent,
  ],
  providers: [MwDialogService],
})
export class MwDialogModule {}
